import { In } from 'typeorm'
import { getContextPath, getRepository } from '@things-factory/shell'

import { Board } from '../service/board/board.js'
import { BoardHistory } from '../service/board/board-history.js'

export const headlessModel = async (target, draft: boolean = false) => {
  var { domain, id, model, name } = target || {}

  if (model) {
    if (typeof model === 'string') {
      model = JSON.parse(model)
    } else if (typeof model !== 'object') {
      throw new Error('model should be a string or object')
    }
  } else {
    if (id) {
      var board = await getRepository(Board).findOne({
        where: { domain: { id: In([domain.id, domain.parentId].filter(Boolean)) }, id }
      })
    } else if (name) {
      var board = await getRepository(Board).findOne({
        where: { domain: { id: In([domain.id, domain.parentId].filter(Boolean)) }, name }
      })
    } else {
      throw new Error('parameter model or id mandatory')
    }

    if (!draft && board) {
      const latestReleased =
        board.state === 'released'
          ? board
          : await getRepository(BoardHistory)
              .createQueryBuilder('history')
              .where('history.originalId = :originalId', { originalId: board.id })
              .orderBy('history.version', 'DESC')
              .limit(1)
              .getOne()

      model = (latestReleased || board).model
    } else {
      model = board.model
    }

    model = JSON.parse(model)
  }

  return {
    base: getContextPath(domain),
    model,
    board
  }
}
